export const HOST_BALANCE_CHANGED_EVENT = 'c7:auth:balance-changed';

export function notifyHostBalanceChanged(nextBalance: number | string | null | undefined): void {
  const parsedBalance = Number(nextBalance);
  if (!Number.isFinite(parsedBalance)) return;
  if (typeof window === 'undefined') return;

  window.dispatchEvent(new CustomEvent(HOST_BALANCE_CHANGED_EVENT, {
    detail: { balance: parsedBalance },
  }));
}
